import React, { useContext } from 'react';
import classNames from 'classnames';
import { NavigationButton } from '../components/Buttons';
import { HexpertContext } from '../contexts/HexPertProvider';
import { PageProps } from '../types/hexpertTypes';

export const HexpertStart = ({ Title, SubTitle, Description, StartLabel }: PageProps) => {
  const { state, dispatch } = useContext(HexpertContext);

  const onClickNavigationButton = () => {
    dispatch({ type: 'setStartForm' });
    dispatch({ type: 'isInitialForceModal', payload: true });
  };

  return (
    <div
      className={classNames('c-hex-start-container', {
        'c-hex-start-container-fadeout': state?.startForm,
      })}
    >
      {Title && <h1 className='c-hex-title'>{Title}</h1>}
      {SubTitle && <h2 className='c-hex-subtitle'>{SubTitle}</h2>}
      {Description && (
        <div className='c-hex-description' dangerouslySetInnerHTML={{ __html: Description }} />
      )}
      {StartLabel && <NavigationButton label={StartLabel} action={onClickNavigationButton} />}
    </div>
  );
};
